import React, { useState } from 'react';
import { useFormik } from 'formik';
import { Button } from 'primereact/button';
import { InputTextarea } from 'primereact/inputtextarea';
import { classNames } from 'primereact/utils';

function RejectTimesheetPopup({ updateRejectRow, onClose }) {
    const [formData, setFormData] = useState({});
    const formik = useFormik({
        initialValues: {
            reason: '',
        },
        validate: (data) => {
            let errors = {};
            if (!data.reason) { errors.reason = 'Please add your reason.'; }
            return errors;
        },
        onSubmit: (data) => {
            setFormData(data);
            updateRejectRow(data);
            onClose();
        }
    });

    const isFormFieldValid = (name) => !!(formik.touched[name] && formik.errors[name]);
    const getFormErrorMessage = (name) => {
        return isFormFieldValid(name) && <small className="p-error">{formik.errors[name]}</small>;
    };

    const onCloseMethod = () => {
        onClose();
    }

    const rejectPopupForm = (
        <React.Fragment>
            <form onSubmit={formik.handleSubmit} className="p-fluid p-grid" autoComplete="off">
                <p>Please mention your reason to reject this timesheet.</p>
                <div className='p-field'>
                    <InputTextarea
                        id="reason"
                        name="reason"
                        value={formik.values.reason}
                        onChange={formik.handleChange}
                        rows={5}
                        cols={44}
                        autoResize
                        className={classNames({ 'p-invalid': isFormFieldValid('reason') })}
                    />
                    {getFormErrorMessage('reason')}
                </div>
                <div className='pt-3'>
                    <div className='grid' style={{ float: 'right' }}>
                        <div className='mr-2'>
                            <Button type="button" label="Cancel" icon="pi pi-times" className="p-button-rounded p-button-secondary" onClick={(e) => onCloseMethod(e)} />
                        </div>
                        <div >
                            <Button type="submit" label="Reject" icon="pi pi-check" className="p-button-rounded pi-button-secondary" style={{ "backgroundColor": "red" }} />
                        </div>
                    </div>
                </div>
            </form>
        </React.Fragment>
    );

    return (
        <React.Fragment>
            {rejectPopupForm}
        </React.Fragment>
    )
}

export default RejectTimesheetPopup;